"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsEditors_en_us = void 0;
function componentsEditors_en_us() {
    return {
        "components.editors.monaco.editorloading": "Editor is loading",
        "components.editors.styleeditor.csstitle": "Custom Styles",
        "components.editors.styleeditor.cssclasstitle": "Custom CSS Classes",
        "components.editors.styleeditor.cssclasshint": "Here you can add your own css classes",
        "components.editors.styleeditor.addnewstyle": "Add new style"
    };
}
exports.componentsEditors_en_us = componentsEditors_en_us;
